<div class="resume__budget bg-white" *ngIf="model != null">

  <div class="w-100 text-center">
    <img src="../../../../assets/images/cupra-garage-logo.svg" alt="CUPRA Garage" class="cupra__garage">
  </div>
  <div class="card">
    <img [src]="pathServer + model.ModelVersion.ModelImage" class="card-img-top" alt="{{model.ModelVersion.Model}}">
    <div class="card-body text-center">
      <small>{{model.CreationDate | date: 'dd/MM/yyyy'}}</small><br>
      <h5 class="card-title">{{model.ModelVersion.Model}}</h5>
      <small *ngIf="model.Matricula">{{model.Matricula}}</small><br>
      <small *ngIf="model.Bastidor">{{model.Bastidor}}<br></small>
      <small>{{model.ModelVersion.MotorType}}</small>
      <h6 class="card-subtitle mb-2">{{model.ModelVersion.Version}}</h6>
      <div class="data__life_car">{{model.Km | number}} km | {{model.Months}} Meses</div>
    </div>
    <div class="card-footer">
      <div class="location" *ngIf="model.IdDistributor == null">{{model.Province}}</div>
      <div class="location" *ngIf="model.IdDistributor != null">
        <div>
          <div class="card-distributor">{{model.Distributor}}</div>
          <small>
            <ng-container *ngIf="model.DistributorAddress != null">{{model.DistributorAddress}}<br /></ng-container>
            <ng-container *ngIf="model.DistributorCity != null">{{model.DistributorCity}}<br /></ng-container>
            <ng-container *ngIf="model.DistributorCp != null">{{model.DistributorCp}}<br /></ng-container>
            <ng-container *ngIf="model.Province != null">{{model.Province}}<br /></ng-container>
            <ng-container *ngIf="model.DistributorPhone != null">{{model.DistributorPhone}}</ng-container>
          </small>
        </div>
      </div>
    </div>
  </div>
  <h5>Presupuesto estimado</h5>
  <table cellPadding="0" cellSpacing="0" class="resume__calc">
    <tr *ngFor="let selectOp of model.BudgetOperations">
      <td class="w-70">{{selectOp.Operation}}</td>
      <td class="w-30">{{selectOp.FinalPrice | currency: 'EUR'}}</td>
    </tr>
    <tr *ngFor="let selectPieza of model.BudgetPiezaDesgaste">
      <td class="w-70">{{selectPieza.Pieza}} <br /><small *ngIf="selectPieza.ShowOption">{{selectPieza.Option}}</small></td>
      <td class="w-30">{{selectPieza.FinalPrice | currency: 'EUR'}}</td>
    </tr>
  </table>
  <table cellPadding="0" cellSpacing="0" class="resume__calc mt-4">
    <tr>
      <td class="w-70">Precio total</td>
      <td class="w-30 total">{{model.BudgetPrice | currency: 'EUR'}}</td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="legal">
          Presupuesto con Impuestos<br>
          Presupuesto orientativo, pendiente de validación en el mismo momento de la cita con tu Servicio Especialista CUPRA
        </div>
      </td>
    </tr>
  </table>
</div>